export default __webpack_public_path__ + "static/media/mobileFaderImage4.e093990f.png";